import { Tracker } from 'services/tracking';
import { GA_CATEGORIES } from 'consts/analytics/ga';
import { HOSTED_PAGE_TYPES } from 'consts/global';
import { CATEGORIES, GA_EVENT_BY_CARD_PAYMENT_STATUS } from 'consts';

const tracker = new Tracker(HOSTED_PAGE_TYPES.demo);

export const trackSigUpClick = () => {
  tracker.fireEvent({
    category: GA_CATEGORIES.SIGN_UP_CLICK,
    action: GA_CATEGORIES.SIGN_UP_CLICK
  });
};

export const trackDocsClick = () => {
  tracker.fireEvent({
    category: GA_CATEGORIES.EXPLORE_DOCS,
    action: GA_CATEGORIES.EXPLORE_DOCS
  });
};

export const trackOpenShareModal = () => {
  tracker.fireEvent({
    category: GA_CATEGORIES.OPEN_SHARE_DEMO_MODAL,
    action: GA_CATEGORIES.OPEN_SHARE_DEMO_MODAL
  });
};

export const trackTestCardsModal = () => {
  tracker.fireEvent({
    category: GA_CATEGORIES.OPEN_TEST_CARDS_MODAL,
    action: GA_CATEGORIES.OPEN_TEST_CARDS_MODAL
  });
};

export const trackCardSubmit = (status: string) => {
  const gaValue =
    GA_EVENT_BY_CARD_PAYMENT_STATUS[
      status as keyof typeof GA_EVENT_BY_CARD_PAYMENT_STATUS
    ];

  tracker.fireEvent({
    category: gaValue,
    action: gaValue
  });
};

export const trackCategorySubmit = (category: CATEGORIES) => {
  tracker.fireEvent({
    category: `${GA_CATEGORIES.PAYMENT_SUBMIT}_${category}`,
    action: `${GA_CATEGORIES.PAYMENT_SUBMIT}_${category}`
  });
};

export const trackDigitalWalletClick = (providerEvent: string) => {
  tracker.fireEvent({
    category: providerEvent,
    action: providerEvent
  });
};
